import React from "react";
import { StyledTable } from "./styledCartTable";

const CartTableComponent = ({ theadData, children, className }) => {
  return (
    <StyledTable bordered className={`text-center w-100 ${className}`}>
      <thead>
        <tr>
          {theadData.map((item) => (
            <th key={`th-${item.id}`}>{item.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </StyledTable>
  );
};

export default CartTableComponent;
